const curriculum = ["British", "American", "Pakistan FBISE", "Other"];
const curriculumSubjects = [
  "Accounting - 9706",
  "Afrikaans - Language (AS Level only) - 8679",
  "Arabic - 9680",
  "Arabic - Language (AS Level only) - 8680",
  "Art & Design - 9479",
  "Biology - 9700",
  "Chemistry - 9701",
  "Chinese - Language & Literature (A Level only) - 9868 New",
  "Chinese Language (AS Level only) - 8238 New",
  "Classical Studies - 9274",
  "Computer Science - 9618",
  "Design & Technology - 9705",
  "Digital Media & Design - 9481",
  "Drama - 9482",
  "Economics - 9708",
  "English - Language and Literature (AS Level only) - 8695",
  "English - Literature - 9695",
  "English General Paper (AS Level only) - 8021",
  "English Language - 9093",
  "Environmental Management (AS only) - 8291",
  "European History - 9981 New",
  "French - Language (AS Level only) - 8682",
  "French (A Level only) - 9716",
  "French Language & Literature - 9898",
  "French Language (AS Level only) - 8028",
  "Geography - 9696",
  "German - Language (AS Level only) - 8027",
  "German - Language (AS Level only) - 8683",
  "German (A Level only) - 9717",
  "German Language & Literature (A Level only) - 9897",
  "Global Perspectives & Research - 9239",
  "Hinduism - 9487",
  "History - 9489",
  "Information Technology - 9626",
  "International History - 9982 New",
  "Islamic Studies - 9488",
  "Law - 9084",
  "Marine Science - 9693",
  "Mathematics - 9709",
  "Mathematics - Further - 9231",
  "Media Studies - 9607",
  "Music - 9483",
  "Physics - 9702",
  "Portuguese - Language (AS Level only) - 8684",
  "Portuguese (A Level only) - 9718",
  "Psychology - 9990",
  "Sociology - 9699",
  "Spanish - Language & Literature (A Level only) - 9844 New",
  "Spanish Language (AS Level only) - 8022 New",
  "Tamil - 9689 (A Level only)",
  "Tamil - Language - 8689 (AS Level only)",
  "Thinking Skills - 9694",
  "Travel & Tourism - 9395",
  "Urdu - Language (AS Level only) - 8686",
  "Urdu - Pakistan only (A Level only) - 9686",
  "Urdu (A Level only) - 9676",
  "US History since 1877 - 8102 New",
  "US History to 1877 - 8101 New",
];

const currculumGrade1 = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];
const currculumGrade2 = ["A*", "A", "B", "C", "D", "E", "U"];
export { curriculum, curriculumSubjects, currculumGrade1, currculumGrade2 };
